/* Calendar logic */

const dashboardSearchBindings = new WeakMap();

export function formatDate(date) {
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const year = date.getFullYear();
	return `${month}/${day}/${year}`;
}

export function getDatesBetween(startDate, endDate) {
	const dates = [];
	let currentDate = new Date(startDate);

	while (currentDate <= endDate) {
		dates.push(new Date(currentDate));
		currentDate.setDate(currentDate.getDate() + 1);
	}

	return dates;
}

export function getShortTimezone(ianaTimezone) {
	try {
		return new Intl.DateTimeFormat('en-US', {
			timeZone: ianaTimezone,
			timeZoneName: 'short'
		}).formatToParts(new Date()).find(part => part.type === 'timeZoneName').value;
	} catch (e) {
		console.error(`Error converting timezone: ${ianaTimezone}`, e);
		return 'UTC';
	}
}

export function ready_timeline_expand(events) {


	var test_container = document.getElementById('event_timeline_combined_timeline');

	//console.log("what is my explore_timeline set to: ", explore_timeline)
	//console.log("what is my test_container set to: ", test_container)

	if (typeof explore_timeline == 'undefined') {
		//console.log("no timeline exists, lets make it...");
		make_timeline_control();
	} else {
		if (test_container == null) {
			//console.log("time to reload timeline");
			location.reload();
		}
	}


	let date_start_js = moment();
	let date_end_js = moment();


	try {

		if (document.querySelector("#date_start")) {
			date_start_js = document.querySelector("#date_start").value;
			date_start_js = moment(date_start_js);
		}
		if (document.querySelector("#date_end")) {
			date_end_js = document.querySelector("#date_end").value;
			date_end_js = moment(date_end_js);
		}

		//console.log("date_start_js", date_start_js)
		//console.log("date_end_js", date_end_js)

	} catch (error) {
		console.error(error);
	}



	var categories_available = document.getElementById("event_cats").value
	categories_available = JSON.parse(categories_available)
	//console.log("categories_available", categories_available);
	let get_resources = window.get_resources_by_event_types(categories_available)
	//console.log("get_resources", get_resources);

	groups = []



	let lastid = 0;
	for (resource in get_resources) {
		//console.log(get_resources[resource])
		var item_content = document.createElement('div');
		item_content.className = "events-cont"




		var item_content_name = document.createElement('div');
		item_content_name.className = 'events-name';
		item_content_name.appendChild(document.createTextNode(get_resources[resource].name));
		item_content.appendChild(item_content_name);

		var item_content_title = document.createElement('div');
		item_content_title.className = 'events-title';
		item_content_title.appendChild(document.createTextNode(get_resources[resource].title));
		item_content.appendChild(item_content_title);

		var item_image_container = document.createElement('div');
		item_image_container.className = "events-img-explore";
		var item_image = document.createElement('img');
		item_image.src = get_resources[resource].img;
		item_image.style.width = '24px';
		item_image_container.appendChild(item_image);

		item_content.appendChild(item_image_container);
		item_id = get_resources[resource].id;
		if (item_id >= lastid) {
			lastid = item_id;
		}



		group_data = {
			id: get_resources[resource].id,
			content: item_content,
			color: get_resources[resource].color
		}

		groups.push(group_data)
	}
	lastid = lastid + 1;
	//console.log("last id last id", lastid)
	var all_content = document.createElement('div');
	all_content.className = 'events-alldata-explore';
	all_content.appendChild(document.createTextNode("All Filter Events"));

	group_data = {
		id: lastid,
		content: all_content
	}
	groups.push(group_data);



	var item_count = 0;
	timeline_events = [];
	if (events) {
		//console.log("render these events", events);
		for (event in events) {
			//console.log("event", events[event])
			//console.log("waht type", events[event].event_data.type)
			var category_input = categories_available[events[event].event_data.type].rank;
			var category_color = categories_available[events[event].event_data.type].color;
			var category_font_color = getContrastColor(category_color);


			//console.log("put the item in category_input", category_input)
			var item_details = {
				id: item_count,
				content: "<div class='explore_text'>" + events[event].event_data.name + "</div><div class='explore_smalltext'>12:00 to 13:00</div>",
				start: events[event].event_start,
				group: category_input,
				style: "background-color:" + category_color + "; border-color:" + category_color + "; color:" + category_font_color,
				wingmanid: events[event].event_id,
				resource_color: category_color,
				event_data: events[event].event_data

			}
			timeline_events.push(item_details)


			item_count = item_count + 1;
			var item_all = {
				id: item_count,
				start: events[event].event_start,
				end: events[event].event_end,
				group: lastid,
				selectable: false,
				type: 'background',
				style: "background-color:" + category_color,

			}
			timeline_events.push(item_all)
			item_count = item_count + 1;

		}
	}
	//console.log(timeline_events)


	timeline_items = new vis.DataSet(timeline_events);



	explore_timeline.setGroups(groups)
	explore_timeline.setItems(timeline_items)

	//console.log("timeline items and groups set", explore_timeline)
	explore_timeline.fit();
	//console.log("timeline set to fit");

	explore_timeline.on("click", function (properties) {
		//console.log("properties", properties.item)
		if (properties.item) {
			//console.log(timeline_items, properties.item);
			const item = timeline_items.get(properties.item);
			//console.log("timeline clicked: ", item.wingmanid);
			//window.location.href = "/events/details?event=" + item.wingmanid;
			window.open(
				"/events/details?event=" + item.wingmanid,
				'_blank'
			);

		}
	});

	explore_timeline.on('itemover', function (properties) {
		//console.log("properties", properties);

		var itemId = properties.item;
		var item = timeline_items.get(itemId);
		var event_item = { "event": item.event_data }
		event_item["start"] = item.event_data.ts_start;
		event_item["end"] = item.event_data.ts_end;
		event_item["resource_color"] = item.resource_color;
		event_item["domEvent"] = properties.event;

		//console.log("got item", event_item)

		var card_header = document.getElementById('card-header');
		var card_title = document.getElementById('card-title');

		var resource = get_resources.find(function (robj) {
			return robj.id === event_item.event.resource;
		});

		window.populate_card(event_item, 'custom-event-tooltip-popup')

		card_header.style.backgroundColor = event_item.resource_color;
		card_title.innerHTML = event_item.event.name;
		clearTimeout(window.WingmanState.tooltiptimer);
		window.WingmanState.tooltiptimer = null;
		//console.log('Hovered over item:', item.content);
	});

	explore_timeline.on('itemout', function (properties) {
		//console.log("hoverout", window.WingmanState.tooltiptimer)
		if (!window.WingmanState.tooltiptimer) {
			window.WingmanState.tooltiptimer = setTimeout(function () {
				window.WingmanState.tooltip.close();
				//console.log("close hover")
			}, 100);
		}

	});

	let filter_loader = document.getElementById("event_timeline_loading");
	filter_loader.classList.add("btn-hide");
	//explore_is_debounce_results = true;


}

export function make_timeline_control() {
	var parent_container = document.getElementById('event_timeline_combined');

	var new_container = document.createElement("div");
	new_container.setAttribute("id", "event_timeline_combined_timeline");

	//parent_container.insertBefore(new_container);
	prependChild(parent_container, new_container)
	var container = document.getElementById('event_timeline_combined_timeline');


	let date_start_js = moment();
	let date_end_js = moment();


	try {

		if (document.querySelector("#date_start")) {
			date_start_js = document.querySelector("#date_start").value;
			date_start_js = moment(date_start_js);
		}
		if (document.querySelector("#date_end")) {
			date_end_js = document.querySelector("#date_end").value;
			date_end_js = moment(date_end_js);
		}

		//console.log("date_start_js", date_start_js)

	} catch (error) {
		console.error(error);
	}



	var options = {
		width: '100%',
		autoResize: true,
		editable: false,
		horizontalScroll: false,
		start: date_start_js,
		end: date_end_js,
		max: date_end_js,
		min: date_start_js,
		moment: function (date) {
			return vis.moment(date).utc();
		},
		orientation: {
			axis: "both",
			item: "bottom"
		},
		showCurrentTime: true,
		zoomable: false,
		snap: function (date, scale, step) {
			var hour = 60 * 60 * 1000;
			return Math.round(date / hour) * hour;
		},
		groupOrder: function (a, b) {
			//return b.id - a.id;
		},
		xss: {
			disabled: false,
			filterOptions: {
				whiteList: { img: ['src', 'class'], div: 'class' }
			},
		}



	};

	// Create a Timeline
	//console.log("create new timeline")
	explore_timeline = new vis.Timeline(container, [], options);
	//console.log("timeline created", explore_timeline)
}

export function change_event_timezone(_args) {
	let timezoneVal = _args;

	// Accept legacy callers that passed Arguments/Array payloads.
	if (timezoneVal && typeof timezoneVal === 'object') {
		if (Object.prototype.toString.call(timezoneVal) === '[object Arguments]' || Array.isArray(timezoneVal)) {
			timezoneVal = timezoneVal[0];
		} else if (typeof timezoneVal.timezone === 'string') {
			timezoneVal = timezoneVal.timezone;
		}
	}

	if (typeof timezoneVal !== 'string' || timezoneVal.trim() === '') {
		console.warn('change_event_timezone: invalid timezone value, skipping update', timezoneVal);
		return;
	}

	timezoneVal = timezoneVal.trim();
	//console.log("update calendar to " + timezoneVal)
	//console.log("window.WingmanState.eventcalendarObj", window.WingmanState.eventcalendarObj);
	if (window.WingmanState.eventcalendarObj) {
		window.WingmanState.eventcalendarObj.setOptions({
			displayTimezone: timezoneVal,
		});
	}


}

export function calendar_loader_hide() {
	let loader = document.getElementById("calendar_loading");
	loader?.classList.add("hide");
}

export function calendar_loader_show() {
	let loader = document.getElementById("calendar_loading");
	loader?.classList.remove("hide");
}

export function make_explore_timeline(events) {

	ready_timeline_expand(events);

}

export function clean_explorer_timeline(_args) {

	let args = Array.from(arguments)
	let explorer_update = args[0]

	//console.log("clean_explorer_timeline", arguments)

	if (explorer_update == "explore-clear-filters") {
		//console.log("start clear")


		let efp = explore_filters_picker[0].selectize;
		efp.destroy();

		explore_set_filters = "";
		//console.log("end clear");

		var fsa = document.getElementById("filter_select_area");
		var sa = document.createElement("div");
		sa.setAttribute('class', 'filter_dropdown_area');
		sa.setAttribute("id", "filter_dropdown_area");

		fsa.replaceWith(sa);

		if (typeof explore_timeline != 'undefined') {
			explore_timeline.setItems([]);
		}
		make_selected_filters();
	}

}

export function makeCalendar(onSearch) {

	/*
				startDay: window.calStartDay,
				endDay: window.calEndDay
	*/

	//console.log("creating calendar for: ", window.get_start_date, window.get_end_date, window.calType, "date_range", window.get_date_range, "start_day", window.calStartDay, "end_day", window.calEndDay)

	var timezone_value_default = "UTC";
	if (document.querySelector("#timezone_selected") && typeof document.getElementById("timezone_selected").value === "string" && document.getElementById("timezone_selected").value !== "") {
		timezone_value_default = document.getElementById("timezone_selected").value;
	}
	var calOptions = {}
	if (window.calType == "week") {
		calOptions = {
			type: window.calType,
			size: window.get_date_range,
			startDay: window.calStartDay,
			endDay: window.calEndDay,
			startTime: '00:00',
			endTime: '23:59',
			eventList: false,
			timeCellStep: 720,
			timeLabelStep: 720,
			showControls: false,
		}
	} else if (window.calType == "month") {
		if (window.calEndDay == 7) {
			window.calEndDay = 0
		}
		calOptions = {
			type: "week",
			size: 2,
			startDay: window.calStartDay,
			endDay: window.calEndDay,
			startTime: '00:00',
			endTime: '23:59',
			eventList: false,
			timeCellStep: 1440,
			timeLabelStep: 1440,
			showControls: false,
		}
	} else {
		//console.log("special options for day: change ", window.get_start_date, " -> ", window.get_end_date)
		window.get_start_date = window.get_start_date;

		if (window.calEndDay == 7) {
			window.calEndDay = 0
		}

		calOptions = {
			type: "week",
			startDay: window.calStartDay,
			endDay: window.calEndDay,
			eventList: false,
			timeCellStep: 360,
			timeLabelStep: 360,
			showControls: false,
		}
	}




	//console.log(calOptions);
	if (window.WingmanState.customer_events) {
		//console.log("no need to get window.WingmanState.customer_events_categories, already exists in makeCalendar", window.WingmanState.customer_events)
	} else {
		window.updateCustomerEventCats();
	}

	let get_resources = window.get_resources_by_event_types(window.WingmanState.customer_events)

	//var currentEvent;
	//var timer;



	var formatDate = mobiscroll.formatDate;


	mobiscroll.momentTimezone.moment = moment;


	window.WingmanState.eventcalendarObj = mobiscroll.eventcalendar('#eventcalendar', {
		view: {
			timeline: calOptions
		},
		data: [],
		dataTimezone: 'utc',
		displayTimezone: timezone_value_default,
		timezonePlugin: mobiscroll.momentTimezone,

		resources: get_resources,

		onEventClick: function (args, inst) {
			args_handle = args;

			// create the cards, all as popups
			//create_card(args, inst);


			//setTimeout(function () {
			//	create_card(args, inst);
			//}, 1)

			//resourceModal.show();

		},
		renderResource: function (resource) {
			return '<div class="events-cont">' +
				'<div class="events-name">' + resource.name + '</div>' +
				'<div class="events-title">' + resource.title + '</div>' +
				'<img class="events-img" src="' + resource.img + '"/>' +
				'</div>';
		},
		renderDay: function (day) {
			var date = day.date;
			//console.log("date", date);


			return `<div>` + formatDate('DDDD', date) + `</div>` +
				`<p>` + formatDate('MMM DD', date) + `</p>`;
		},
		onPageLoading: function (event, inst) {

		},
		onPageLoaded: function (event, inst) {

			// init all popovers
			// semaphore 
			//console.log("loaded onPageLoaded multiple events", window.get_start_date, event, inst);






			/*
			// bootstrap click popover
			var popoverContent = document.getElementById('event_details');
			var popoverTriggerList = [].slice.call(document.querySelectorAll('.mbsc-timeline-event[data-id]'))
			var popoverList = popoverTriggerList.map(function (e) {
				// 				      trigger: 'focus',
				//						click -> allows for interaction

			  var nbs = new bootstrap.Popover(e, {
				  html: true,
				  trigger: 'hover',
				  animation: false,
				  content: popoverCard,
				  placement: 'bottom',
				  template: '<div class="popover event-popover" role="window.WingmanState.tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
			  })

			  e.addEventListener('shown.bs.popover', function () {
				 clean_popovers();
				})


			  return true;
			})
			
			*/



			let elist = document.querySelectorAll('.mbsc-timeline-event[data-id]')






			// old pill display for new events
			for (i = 0; i < elist.length; ++i) {

				//new event (not addressed)  .dataset.id == 8

				if (elist[i].classList.contains('md-largevents-bg')) {
					let divi = elist[i];
					let spani = document.createElement("span");
					spani.classList.add("badge", "badge-pill", "badge_large_activity");
					spani.append(" ");
					divi.append(spani);
				}


			}



			loaded_events = true;


		},
		onEventHoverIn: function (args) {
			//console.log("hoverin and populate custom-event-tooltip-popup")


			var event = args.event;


			var resource = get_resources.find(function (robj) {
				return robj.id === event.resource;
			});


			var card_header = document.getElementById('card-header');
			var card_title = document.getElementById('card-title');

			window.populate_card(args, 'custom-event-tooltip-popup')


			card_header.style.backgroundColor = resource.color;
			card_title.innerHTML = event.title;
			//card_range.innerHTML = event.start + " to " + event.end;
			//card_range_duration.innerHTML = event.

			//data.innerHTML = event.title + ', Age: ' + event.age;
			//time.innerHTML = eventTime;
			//status.innerHTML = event.confirmed ? 'Confirmed' : 'Canceled';
			//reason.innerHTML = event.reason;
			//loc.innerHTML = event.location;

			//statusButton.innerHTML = button.text;

			//mobiscroll.getInst(statusButton).setOptions({ color: button.type });

			clearTimeout(window.WingmanState.tooltiptimer);
			window.WingmanState.tooltiptimer = null;

			//window.WingmanState.tooltip.setOptions({ anchor: args.domEvent.target });
			//window.WingmanState.tooltip.open();
			if ("related_event_id" in args.event) {
				connections_obj = []
				event_related_items = args.event.related_event_id
				//console.log("event_related_items", event_related_items)
				for (eri in event_related_items) {
					//console.log(event_related_items[eri])	
					newconnection = {
						from: args.event.id,
						to: event_related_items[eri],
						color: resource.color,
						arrow: 'to',
						type: 'ss'
					}
					connections_obj.push(newconnection)
				}
				window.WingmanState.eventcalendarObj.setOptions({
					connections: connections_obj
				});
			}


		},
		onEventHoverOut: function () {
			//console.log("hoverout")
			if (!window.WingmanState.tooltiptimer) {
				window.WingmanState.tooltiptimer = setTimeout(function () {
					window.WingmanState.tooltip.close();
					//console.log("close hover")
				}, 100);
			}
			window.WingmanState.eventcalendarObj.setOptions({
				connections: []
			});
		},
		

		selectedDate: window.get_start_date,
		refDate: window.get_start_date
	});


	//document.body.appendChild(exp_hover_card)


	//console.log("add search listener for calendar");


	const search = document.getElementById('search_events');
	if (search) {
		dashboardSearchBindings.get(search)?.();
		let timer;
		const listener = () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				if (document.getElementById('search_events') === search) onSearch(search.value);
			}, 600);
		};
		search.addEventListener('input', listener);
		dashboardSearchBindings.set(search, () => {
			clearTimeout(timer);
			search.removeEventListener('input', listener);
		});
	}





}

export function makeCalendarTooltip() {
	//console.log("make window.WingmanState.tooltip custom-event-tooltip-popup")
	//document.body.insertAdjacentHTML( 'beforeend', exp_hover_card );

	//window.WingmanState.tooltip.destroy();

	window.WingmanState.tooltip = mobiscroll.popup('#custom-event-tooltip-popup', {
		display: 'anchored',
		context: 'body',
		showArrow: false,
		theme: 'material',
		maxHeight: 1000,
		focusOnClose: false,
		touchUi: false,
		showOverlay: false,
		contentPadding: false,
		closeOnOverlayClick: false,
		width: 550,
		onInit: function () {
			document.getElementById('custom-event-tooltip-popup').addEventListener('mouseenter', function () {
				//console.log("moseovercard")
				if (window.WingmanState.tooltiptimer) {
					clearTimeout(window.WingmanState.tooltiptimer);
					window.WingmanState.tooltiptimer = null;
				}
			});

			document.getElementById('custom-event-tooltip-popup').addEventListener('mouseleave', function () {
				//console.log("mouseleavecard")
				window.WingmanState.tooltiptimer = setTimeout(function () {
					window.WingmanState.tooltip.close();
				}, 44400);
			});
		},
	});

	var popoverobj = document.getElementById("custom-event-tooltip-popup");
	var dexpandchart = popoverobj.querySelector("#card-event-chart-toggle");
	var dchartarea = popoverobj.querySelector("#card-event-chart");
	var dcharttwisty = popoverobj.querySelector(".btn-showhide-card");

	dexpandchart.addEventListener("click", function (e) {
		if (dchartarea.classList.contains("img-small-version")) {
			dchartarea.classList.remove("img-small-version");
			dcharttwisty.innerHTML = "▼";
		} else {
			dchartarea.classList.add("img-small-version");
			dcharttwisty.innerHTML = "▶";
		}

		e.preventDefault();
		return false;
	})

	var dexpandcause = popoverobj.querySelector("#card-event-cause-toggle");
	var drootcause = popoverobj.querySelector("#card-root-cause");
	var dcausetwisty = popoverobj.querySelector(".btn-showhide-cause");
	dexpandcause.addEventListener("click", function (e) {
		if (drootcause.classList.contains("btn-hide")) {
			drootcause.classList.remove("btn-hide");
			dcausetwisty.innerHTML = "▼";
		} else {
			drootcause.classList.add("btn-hide");
			dcausetwisty.innerHTML = "▶";
		}

		e.preventDefault();
		return false;
	})

}

export function getDates() {
	//console.log("Get Dates to determine the ranges")

	let date_start = document.getElementById("date_start");
	let date_end = document.getElementById("date_end");
	let date_range = document.getElementById("date_range");

	window.get_date_range = parseInt(date_range.value);
	window.get_start_date = moment.utc(date_start.value);
	window.get_end_date = moment.utc(date_end.value);
	window.calStartDay = window.get_start_date.weekday();
	window.calEndDay = window.get_end_date.weekday();

	//console.log(window.get_start_date, window.get_end_date, window.get_date_range, window.calStartDay, window.calEndDay)
	//console.log("Eval Date Range", window.get_date_range)
	if (window.get_date_range >= 7 && window.get_date_range <= 13) {
		//console.log("this is a week long range")
		window.calType = "week"
		window.get_date_range = 1
	} else if (window.get_date_range >= 14) {
		//console.log("this is a 14 day range")
		window.calType = "week"
		window.get_date_range = 2
	} else {
		//console.log("this is a 3 day range")
		window.calType = "day"
		window.get_date_range = window.get_date_range; // + 1
	}

	if (window.calType == "week") {
		if (window.calEndDay == window.calStartDay) {
			window.calEndDay = window.calEndDay - 1;
			if (window.calEndDay >= 7) {
				window.calEndDay = 0;
			}
		}
	} else {
		//console.log("fix day end")
		if ((window.calEndDay == 0) && (window.calStartDay > window.calEndDay)) {
			window.calEndDay = 7
		}
	}


	//console.log("getDates", window.calType, window.get_date_range, window.get_start_date, window.get_end_date, window.calStartDay, window.calEndDay)


}
